import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SweetAlert from 'sweetalert-react';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect, Link } from 'react-router-dom';
import { renderToStaticMarkup } from 'react-dom/server';

import { companyWebsite, name, storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler } from 'C4';

import { toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import InputField from 'components/LoginForm/Input';
import SellingPoints from 'components/SellingPoints';

import logo from 'assets/images/logo/logo_white.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const NoAgentScreen = () => (
  <div className="noAgent__container">
    <img src={logo} alt={`${name} logo`} />
    <h5>{i18n.translate('loginScreen.noAgent.title')}</h5>
    <p>{i18n.translate('loginScreen.noAgent.messageWeb')}</p>
    <p>
      <a href={companyWebsite}>{companyWebsite}</a>
    </p>
    <a href={companyWebsite}>
      <button>{i18n.translate('loginScreen.noAgent.visitWebsite')}</button>
    </a>
  </div>
);

export default class Email extends Component {
  constructor() {
    super();
    this.state = {
      noAgent: false,
      redirect: '',
    };

    this.handleCheckEmail = this.handleCheckEmail.bind(this);
    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
  }

  async handleCheckEmail(event) {
    const { setAnim, userInput, userExistsHandler } = this.props;
    const { email } = userInput;
    const submit = event.target;
    submit.disabled = true;
    setAnim('loadingAnim', true);
    if (!email) {
      toast.error(`${i18n.translate('loginScreen.errors.fillInEmail')}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setAnim('loadingAnim', false);
      submit.disabled = false;
    }
    await APIHandler.checkEmail(email).then((res) => {
      userExistsHandler(res.success);
      setAnim('loadingAnim', false);
      submit.disabled = false;
    });
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) StorageHandler.save(storageKeys.user, userInfo, 2592000000);
    document.body.classList.remove('no-scroll');
    this.setState({ redirect: customRedir || '/main' });
  }

  async loginHandler(event) {
    const { checkInputValidity, setAnim, userInput } = this.props;
    const { email, password } = userInput;
    const submit = event.target;
    submit.disabled = true;
    if (checkInputValidity()) {
      event.preventDefault();

      const userExists = await StorageHandler.exists(storageKeys.user);
      if (!userExists) {
        setAnim('loadingAnim', true);
        const appId = await DataHandler.matchAppId();
        const response = await APIHandler.loginUser(email, password);
        const user = await APIHandler.getUser(appId, response.access_token);

        if (response.error || response.success === false) {
          submit.disabled = false;
          toast.error(response.message, {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return;
        }

        StorageHandler.save(storageKeys.accessToken, response.access_token);
        StorageHandler.save(storageKeys.refreshToken, response.refresh_token, response.expires_in);
        setAnim('loadingAnim', true);
        submit.disabled = true;

        if (Object.keys(user).length > 0) {
          this.login(user, true);
          return;
        }
      }
      // TODO test
      StorageHandler.load(storageKeys.user)
        .then((userInfo) => { // Loads userInfo from localStorage
          submit.disabled = false;
          this.login(userInfo, false);
        });
    } else {
      submit.disabled = false;
      setAnim('loadingAnimRegister', false);
    }
  }

  render() {
    const { noAgent, redirect } = this.state;
    const {
      change, loadingAnim, userExists, userInput,
    } = this.props;
    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    let buttonText = i18n.translate('loginScreen.continueButton');
    let buttonFunction = this.handleCheckEmail;
    if (userExists === true) {
      buttonText = i18n.translate('loginScreen.loginButton');
      buttonFunction = this.loginHandler;
    }
    if (userExists === false) {
      buttonText = i18n.translate('loginScreen.otherEmailButton');
      buttonFunction = this.handleCheckEmail;
    }

    return (
      <div className="Email">
        <SweetAlert
          title=""
          show={noAgent}
          html
          text={renderToStaticMarkup(<NoAgentScreen close={close} />)}
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        />
        <div className="logoWelcome">
          <img src={logo} alt={name} />
        </div>

        <h1>{i18n.translate('loginScreen.welcome.headerTop')}</h1>
        <div className="Email__input">
          <legend>
            {i18n.translate('loginScreen.emailPrompt')}
            <br />
          </legend>
          <InputField
            defaultVal={userInput.email}
            change={change}
            fieldType="email"
            fieldName="email"
            fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
            icon="at"
          />

          {userExists && (
            <InputField
              change={change}
              fieldType="password"
              fieldName="password"
              fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
              icon="key"
              autocomplete="password"
              line
            />
          )}

          <div className="login__form--buttons">
            <div className="Email__input--holder">
              {userExists === false && (
                <Link to="/login/register">
                  <button
                    type="button"
                    className="Email__input--button btnInverse"
                  >
                    {i18n.translate('loginScreen.createAccountButton')}
                  </button>
                </Link>
              )}
              <button
                type="submit"
                onClick={buttonFunction}
                className="Email__input--button"
              >
                {loadingAnim ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : buttonText}

                {redirect.length > 0 && <Redirect to={redirect} />}
              </button>
            </div>
            {userExists && (
              <Link to="/login/forgot">
                <button className="Email__input--button btnInverse">
                  <span className="Email__input--forgotPassword">{i18n.translate('loginScreen.forgotPasswordButton')}</span>
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Email.propTypes = {
  change: PropTypes.func.isRequired,
  checkInputValidity: PropTypes.func.isRequired,
  loadingAnim: PropTypes.bool.isRequired,
  setAnim: PropTypes.func.isRequired,
  userInput: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_state: PropTypes.string,
  }),
  userExists: PropTypes.bool,
  userExistsHandler: PropTypes.func.isRequired,
};

Email.defaultProps = {
  userInput: {
    email: '',
    password: '',
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_state: '',
  },
  userExists: null,
};
